<template>
  <div class="phonerelated">
    <z-notice-bar
      text="举证将占用您3~5分钟，填写越仔细，举报成功概率更高"
      left-icon="https://dl.zhuanstatic.com/fecommon/公告小喇叭.svg"
    >
    </z-notice-bar>
    <div class="content">
      <SelectRadio :Finished="phoneFinish" :radioData="radioData1"></SelectRadio>
      <PhoneCheckBox :Finished="chexboxFinish" v-show="isPhone === 0"></PhoneCheckBox>
      <EvidenceBlock :Finished="evidenceFinish" v-show="isPhone === 1" :evidenceData="evidenceData"></EvidenceBlock>
      <SelectRadio :Finished="outerFinish" v-show="isPhone === 1" :radioData="radioData2"></SelectRadio>
    </div>
    <z-button-group>
      <z-button :loading="sharedData.globalLoading" :disabled="!canSubmit" type="primary" @click="next">{{ isPhone == 1 ? '提交' : '下一步' }}</z-button>
    </z-button-group>
  </div>
</template>

<script>
import { Button, ButtonGroup, NoticeBar } from '@zz-common/zz-ui'
import SelectRadio from '../../components/SelectRadio'
import EvidenceBlock from '../../components/EvidenceBlock'
import PhoneCheckBox from './PhoneCheckBox'

export default {
  name: 'PhoneRelated',
  components: {
    SelectRadio,
    PhoneCheckBox,
    EvidenceBlock,
    zButton: Button,
    zButtonGroup: ButtonGroup,
    'z-notice-bar': NoticeBar
  },
  inject: ['sharedData', 'mergeSubmitData', 'globalSubmit', 'submitData', 'files2PicAndVideo'],
  data() {
    return {
      radioData1: {
        question: '您所交易的商品品类是',
        answer: [
          {
            id: 0,
            desc: '手机'
          },
          {
            id: 1,
            desc: '非手机'
          }
        ]
      },
      radioData2: {
        question: '您与对方是否有平台外沟通',
        answer: [
          {
            id: 0,
            desc: '否'
          },
          {
            id: 1,
            desc: '是',
            outer: true
          }
        ]
      },
      evidenceData: {
        title: '请填写相关凭证',
        text: '请参考凭证提示，上传问题凭证(图片/视频)',
        placeholder: '请简要描述商品问题与交易经过',
        example_title: '凭证示例',
        example_text: '1.功能问题：拍摄上传功能使⽤视频<br>2.配置问题：拍摄上传商品所显示的对应参数信息<br>3.外观问题：拍摄清晰的问题细节图片'
      },
      isPhone: '',
      productCategory: '', //手机或非手机
      choosedIndexs: [], //手机问题index数组
      content: '', //凭证描述 多个用逗号分割
      pics: [], //凭证照片视频 json数组
      outsideCommunication: '', // 是否有站外沟通 0没有 1有  不选传null
      outsidePic: [], //站外沟通凭证照片
      phoneQuestionDesc: '' //手机品类问题描述
    }
  },
  computed: {
    canSubmit() {
      if (this.sharedData.evidenceLoading) return false
      if (this.isPhone === 0) {
        return this.choosedIndexs.length > 0 && this.productCategory !== ''
      }
      if (this.isPhone === 1) {
        if (this.outsideCommunication === 0) {
          return this.content.length >= 5 && this.productCategory !== '' && this.pics.length > 0
        }

        if (this.outsideCommunication === 1) {
          return this.content.length >= 5 && this.productCategory !== '' && this.pics.length > 0 && this.outsidePic.length > 0
        }
      }
      return false
    }
  },
  methods: {
    next() {
      if (this.isPhone === 0) {
        this.mergeSubmitData({
          productCategory: this.productCategory,
          phoneQuestionDesc: this.phoneQuestionDesc,
          pics: '',
          content: '',
          outsideCommunication: '',
          outsidePic: ''
        })
        this.$router.push({
          path: '/newreport/fraud/phonesubmit',
          query: {
            choosedIndexs: this.choosedIndexs
          }
        })
      } else {
        const params = {
          productCategory: this.productCategory,
          pics: JSON.stringify(this.pics),
          content: this.content,
          outsideCommunication: this.outsideCommunication,
          outsidePic: JSON.stringify(this.outsidePic)
        }
        this.mergeSubmitData(params)
        this.globalSubmit(this.submitData)
      }
    },
    phoneFinish(data) {
      this.isPhone = data.evidence
      this.productCategory = data.evidence == 0 ? '手机' : '非手机'
    },
    chexboxFinish(data) {
      this.choosedIndexs = data.choosedIndexs
      this.phoneQuestionDesc = data.desc
    },
    evidenceFinish(data) {
      this.pics = this.files2PicAndVideo(data.files)
      this.content = data.message
    },
    outerFinish(data) {
      this.outsideCommunication = data.evidence
      this.outsidePic = data.outerUpload.map(t => t.url)
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>